import type { StaffRole } from "@apartos/contracts";

export interface CurrentUser {
  id: string;
  propertyId: string;
  propertyName: string;
  email: string;
  name: string;
  role: StaffRole;
  permissions: string[];
}

const baseUrl = import.meta.env.VITE_API_URL ?? "";

export async function getCurrentUser(): Promise<CurrentUser | "bootstrap" | null> {
  const response = await fetch(`${baseUrl}/v1/auth/me`, { credentials: "include" });
  if (response.status === 404) return "bootstrap";
  if (response.status === 401) return null;
  if (!response.ok) throw new Error(`Auth ${response.status}`);
  return (await response.json()).data as CurrentUser;
}

export async function login(email: string, password: string): Promise<CurrentUser> {
  const response = await fetch(`${baseUrl}/v1/auth/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const body = await response.json() as { data?: CurrentUser; error?: string };
  if (!response.ok || !body.data) throw new Error(body.error ?? "Не удалось войти");
  return body.data;
}

export async function logout(): Promise<void> {
  await fetch(`${baseUrl}/v1/auth/logout`, { method: "POST", credentials: "include" });
}

export function hasPermission(user: CurrentUser | null, permission: string | string[]): boolean {
  if (!user || user.permissions.includes("*")) return true;
  const required = Array.isArray(permission) ? permission : [permission];
  return required.some((item) => user.permissions.includes(item));
}

export function homeForRole(role: StaffRole): string {
  if (role === "housekeeper") return "/cleaning";
  if (role === "room_service") return "/room-service";
  if (role === "accountant" || role === "viewer") return "/reports";
  return "/dashboard";
}
